import { ValidationErrors, AbstractControl, FormControl } from '@angular/forms';
import { RootState } from '@next/core-lib/app';
import { Store, select } from '@ngrx/store';
import { of, timer, Observable } from 'rxjs';
import { map, switchMap, withLatestFrom, take } from 'rxjs/operators';

import { Barn } from '../models/cycle.model';
import { departureChicksAmount } from '../store/selectors/departure.selectors';

export const dayOldChickAmountValidator =
  (store: Store<RootState>, barn: FormControl) =>
  (input: AbstractControl): Observable<ValidationErrors | null> =>
    timer(1).pipe(
      withLatestFrom(
        store.pipe(
          select(departureChicksAmount),
          map((f) => (barn.value ? f((barn.value as Barn).id) : 0)),
        ),
      ),
      switchMap(([_, totalDepartureChicksAmount]: [unknown, number]) =>
        parseInt(<string>input.value, 10) >= totalDepartureChicksAmount
          ? of(null)
          : of(<ValidationErrors>{ minAmount: totalDepartureChicksAmount }),
      ),
      take(1),
    );
